export default "__VITE_ASSET__CZ2RM2$c__"